import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { progressAnatomy } from '@chakra-ui/anatomy';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(progressAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    track: {
      borderRadius: 8,
    },
    filledTrack: {
      backgroundColor: getThemes(theme).colors.palette.primary[0],
    },
  });

const warning = (theme: ThemesKeys) =>
  style.definePartsStyle({
    filledTrack: {
      backgroundColor: getThemes(theme).colors.palette.warning[50],
    },
  });

const error = (theme: ThemesKeys) =>
  style.definePartsStyle({
    filledTrack: {
      backgroundColor: getThemes(theme).colors.palette.secondary[50],
    },
  });

const success = (theme: ThemesKeys) =>
  style.definePartsStyle({
    filledTrack: {
      backgroundColor: getThemes(theme).colors.palette.success[50],
    },
  });

export const modalTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    variants: {
      error: error(theme),
      warning: warning(theme),
      success: success(theme),
    },
    defaultProps: {
      size: 'lg',
    },
  });

export default (theme: ThemesKeys) => modalTheme(theme);
